export const reviews = {
  0: {
    text: `This app seriously changed my finances and outlook on the world. It's effortless and does all the heavy lifting for you`,
    authorName: 'Buc-cee',
    appStore: true,
  },
  1: {
    text: `I've wanted to dip my toes into crypto for a while now...Bamboo is just what I needed to get me started`,
    authorName: 'imogenerichards',
    appStore: true,
  },
  2: {
    text: `Honestly love the auto set up, easy to just buy a bit of crypto each week and reap the rewards!`,
    authorName: 'Jezza9_',
    appStore: true,
  },
  3: {
    text: `You don't even know you're saving and investing`,
    authorName: 'MartyMF88',
    appStore: true,
  },
  4: {
    text: 'This app is super easy to use, the perfect beginners investment app',
    authorName: 'Jessssss',
    appStore: true,
  },
  5: {
    text: 'Easy to use and automatically get me exposure to the top cryptos so I can get on with my day job. Brilliant!',
    authorName: 'Timothy Wi',
    appStore: true,
  },
  6: {
    text: 'I love my Bamboo app. I have found it so easy to use and I love that I can control when I want to top up and change my portfolio',
    authorName: 'Western 1987',
    appStore: true,
  },
}
